import { actionTypes } from '../actions';

const initialState = {
  error: false,
  processing: false,
  tokenSuccessfullyVerified: false,
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case actionTypes.TOKEN_VALIDATE_REQUEST:
      return {
        ...state,
        error: false,
        processing: true,
        tokenSuccessfullyVerified: false,
      };

    case actionTypes.TOKEN_VALIDATE_SUCCESS:
      return {
        ...state,
        error: false,
        processing: false,
        tokenSuccessfullyVerified: true,
      };

    case actionTypes.TOKEN_VALIDATE_FAILURE:
      return {
        ...state,
        error: true,
        processing: false,
        tokenSuccessfullyVerified: false,
      };

    case actionTypes.TOKEN_VALIDATE_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/tokenValidation.js